import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { HolderInventory } from "@/components/inventory/HolderInventory";

export const HolderTab = () => {
  const [users, setUsers] = useState([]);
  const [uid, setUid] = useState("");
  useEffect(() => { api.get("/inventory/responsibles").then((r) => setUsers(r.data)); }, []);
  return (
    <div className="max-w-2xl space-y-4" data-testid="inventory-holders-tab">
      <select className="h-10 w-full max-w-sm rounded-md border border-border bg-background px-3 text-sm" value={uid} onChange={(e) => setUid(e.target.value)} data-testid="holder-select">
        <option value="">Elige técnico o responsable…</option>
        {users.map((u) => <option key={u.id} value={u.id}>{u.name}{u.role === "technician" ? " · técnico" : ""}</option>)}
      </select>
      <HolderInventory userId={uid} />
    </div>
  );
};
